import { Routes } from '@angular/router';
import { deactivateGuard } from 'src/app/_shared/guards/can-component-deactivate';

export const SEARCH_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'list',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./search-engine.component').then(c => c.SearchEngineComponent),
    canDeactivate: [deactivateGuard],
    children: [
      { path: 'map', loadComponent: () => import('./map/map.component').then(c => c.MapComponent) },
      { path: 'list', loadComponent: () => import('./list/list.component').then(c => c.ListComponent) },
    ],
  },
];
